import { storage, account } from "@/lib/appwrite";
import { ID } from "appwrite";

export const saveOAuthAvatar = async (
  accessToken: string,
  userId: string,
  size = "648x648"
): Promise<void> => {
  try {
    const bucketId = import.meta.env.VITE_BUCKET_ID_AVATAR_COLLABORATOR!;
    const fileName = `${userId}.png`;

    // Subida de un archivo de texto simple
    try {
      const testFile = new File(["debug"], "debug.txt", { type: "text/plain" });
      await storage.createFile(bucketId, ID.unique(), testFile);
    } catch { }

    // Verifica si el archivo ya existe
    const list = await storage.listFiles(bucketId);
    if (list.files.some(f => f.name === fileName)) {
      return;
    }

    // Metadata de Graph
    const metaResp = await fetch("https://graph.microsoft.com/v1.0/me/photo", {
      headers: { Authorization: `Bearer ${accessToken}` },
    });
    if (!metaResp.ok) {
      return;
    }

    // Descarga del blob
    const url = `https://graph.microsoft.com/v1.0/me/photos/${size}/$value`;
    const resp = await fetch(url, {
      headers: { Authorization: `Bearer ${accessToken}` },
    });
    if (!resp.ok) {
      return;
    }

    const blob = await resp.blob();

    // Sube el blob
    const file = new File([blob], fileName, { type: blob.type });
    const uploaded = await storage.createFile(bucketId, userId, file);

    // Guarda en prefs.avatar
    await account.updatePrefs({ avatar: uploaded.$id });

  } catch { }
};
